<template>
    <component
        :is="sliderComponent"
        :items="sliderItems"
        :preview-only="previewOnly"
        :is-desktop="isDesktop"
    >
        <template #placeholder="{ item }">
            <PlaceholderImage
                :label="item.title"
                bg="var(--color-stack-tile-bg)"
                class="h-full w-full"
            />
        </template>
    </component>
</template>

<script>
import {
    DEFAULT_SLIDER_VARIANT,
    sliderComponents
} from "@/components/catalog/sliders";
import PlaceholderImage from "@/components/editor/PlaceholderImage.vue";

export default {
    name: "BannersSegment",
    components: { PlaceholderImage },
    props: {
        links: { type: Array, required: true },
        variant: { type: String, default: DEFAULT_SLIDER_VARIANT },
        openInNewTab: { type: Boolean, default: false },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    computed: {
        sliderComponent() {
            return (
                sliderComponents[this.variant] ||
                sliderComponents[DEFAULT_SLIDER_VARIANT]
            );
        },
        sliderItems() {
            return this.links.map((link) => ({
                key: link.id,
                href: link.url,
                target: this.openInNewTab ? "_blank" : undefined,
                rel: this.openInNewTab ? "noopener noreferrer" : undefined,
                imageUrl: link.imageUrl,
                imageAlt: link.title,
                title: link.title
            }));
        }
    }
};
</script>
